import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeader = () => ({ Authorization: `Bearer ${getToken()}` });

export const adminLogin = async (password) => {
  const { data } = await axios.post(`${API}/admin/login`, { password });
  setToken(data.token);
  return data;
};

export const verifyAdmin = async () => {
  await axios.get(`${API}/admin/verify`, { headers: authHeader() });
  return true;
};

export const fetchAdminContent = async (variant = "v1") => {
  const { data } = await axios.get(`${API}/content`, { params: { variant } });
  return data;
};

export const saveContent = async (content, variant = "v1") => {
  const { data } = await axios.put(
    `${API}/content`,
    { content, variant },
    { headers: authHeader() }
  );
  return data;
};

export const resetContent = async (variant = "v1") => {
  const { data } = await axios.post(
    `${API}/content/reset`,
    {},
    { headers: authHeader(), params: { variant } }
  );
  return data;
};
